import src from "IMAGE";
export default { src, width: 800, height: 93, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AEQ+OzpFQD08PDg1ND86NzY+OTU1RkE9PEE8ODhHQj89fDEHjAua9vAAAAAASUVORK5CYII="};
